// extracted by mini-css-extract-plugin
export default {"toolbar":"FkCHN","title":"GSbNe"};